import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 *
 * */
@Component({
  selector: 'campfire-teams-training-videos-modal',
  templateUrl: './teams-training-videos.modal.component.html',
  styleUrls: ['./teams-training-videos.modal.component.scss']
})
export class TeamsTrainingVideosModalComponent {
  constructor(private modal: NgbActiveModal) {

  }
}

